import produce from 'immer';

import { emptyArray } from 'Lib/constants/placeholder';
import type { Action } from 'Lib/reduxType';

import { LOCATION_PERMISSION_DENIED } from 'Store/location/constants';

import {
  ONBOARDING_NEXT_PAGE,
  ONBOARDING_RESET,
  ONBOARDING_SKIP,
  ONBOARDING_SWIPE_DEMO_SHOWN,
  Pages,
} from './constants';
import initialState from './initialState';
import type { OnboardingState } from './types';

export const reducer = produce<OnboardingState, [Action]>((draft, action) => {
  let currentPage;
  let newQueue = emptyArray as OnboardingState['pagesQueue'];

  switch (action.type) {
    case ONBOARDING_NEXT_PAGE: {
      const { completedPages, pagesQueue } = draft;

      currentPage = pagesQueue.length && pagesQueue[0];
      newQueue = pagesQueue.slice(1);

      draft.pagesQueue = newQueue;
      draft.completedPages = currentPage
        ? completedPages.concat(currentPage)
        : draft.completedPages;
      draft.onboardingOpen = newQueue.length !== 0;
      break;
    }
    case ONBOARDING_SKIP: {
      draft.onboardingOpen = false;
      draft.completedPages = initialState.pagesQueue;
      draft.pagesQueue = emptyArray;
      draft.didSkipOnboarding = true;
      break;
    }
    case LOCATION_PERMISSION_DENIED: {
      draft.onboardingOpen = true;
      draft.completedPages = draft.completedPages.filter((x) => x !== Pages.LOCATION_SCREEN);
      draft.pagesQueue = newQueue.includes(Pages.LOCATION_SCREEN)
        ? newQueue
        : newQueue.concat(Pages.LOCATION_SCREEN);
      break;
    }
    case ONBOARDING_RESET:
      return initialState;
    case ONBOARDING_SWIPE_DEMO_SHOWN:
      draft.swipeDemoShown = true;
      break;
    default:
      break;
  }
}, initialState);

export const persistConfig = {};
